// extracted by mini-css-extract-plugin
export default {"editor":"EditorStyles_editor__P2ROk","loaderEntry":"EditorStyles_loaderEntry__ugPW8","loader":"EditorStyles_loader__+VkoR"};